import { isDebug, PddPayloadTypes } from "@/constants";
import { Context } from "@/context";
import { useContext, useEffect, useState } from "react";
import { OffscreenCanvas } from "./components/OffscreenCanvas";
import { WorkerStats } from "./components/WorkerStats";
import { usePhysicsListeners } from "./hooks/usePhysicsListeners";
import { useRenderedListeners } from "./hooks/useRenderedListeners";

export const DiceCanvases = () => {
  const { physicsWorker, renderedWorker } = useContext(Context);
  const [isDiceStoreEmpty, setIsDiceStoreEmpty] = useState(true);

  usePhysicsListeners(setIsDiceStoreEmpty);
  useRenderedListeners();

  useEffect(() => {
    if (!(physicsWorker && renderedWorker)) return;

    const handleResize = () => {
      if (isDiceStoreEmpty) return;

      physicsWorker.postMessage({
        type: PddPayloadTypes.ResetStore,
      });
      renderedWorker.postMessage({
        type: PddPayloadTypes.ResetStore,
      });
      setIsDiceStoreEmpty(true);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [isDiceStoreEmpty, physicsWorker, renderedWorker]);

  if (!(physicsWorker && renderedWorker)) return;

  return (
    <>
      <OffscreenCanvas
        worker={physicsWorker}
        style={{
          position: "fixed",
          inset: 0,
          zIndex: 99999999999,
          pointerEvents: "none",
        }}
      />
      <OffscreenCanvas
        worker={renderedWorker}
        frameloop="demand"
        shadows
        style={{
          position: "fixed",
          inset: 0,
          zIndex: 9999999999,
          pointerEvents: "none",
        }}
      />
      {isDebug && <WorkerStats />}
    </>
  );
};
